export const TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const USER_KEY = 'user_data';
export const DIFICULTY_KEY = 'difficulties';
export const LEVEL_KEY = 'levels';
export const LANGUAGE_KEY = 'locale';
export const MISSION_SYNC_KEY = 'mission_sync';

export const MissionFilters = [
  {
    key: 'All',
    value: null
  },
  {
    key: 'Missions',
    value: 0,
  },
  {
    key: 'Challenges',
    value: 1
  }
]

export enum HomeSegments {
  MyMissions = 'my-missions',
  Missions = 'missions',
  Challenges = 'challenges'
}

export const MailRegex: RegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const PhoneRegex: RegExp = /^[6-9]\d{8}$/;

export enum InputTypes {
  Text = 'text',
  Textarea = 'textarea',
}

export enum MissionType {
  Mission = 'Mission',
  Challenge = 'Challenge',
  Section = 'Section'
}

export const MissionColors = {
  [MissionType.Mission]: '#F4742C',
  [MissionType.Challenge]: '#a9df6d'
};
export const STORAGE_FCM_REGISTRATION_ID = 'fcm_registration_id';
